<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.invoice_delivery_types.form.availability')"
            :is-required="true"
            :hint="__('settings.invoice_delivery_types.form.availability_hint')"
        >
            <DSelect
                id="availability"
                v-model="form.availability"
                :options="availabilityTypes"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('availability')"
                :invalid-feedback="errors.availability"
                :selected="form.value"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.invoice_delivery_types.form.public')"
            :error="errors.public"
            :is-required="true"
            :hint="__('settings.invoice_delivery_types.form.public_hint')"
        >
            <DSwitch
                id="public"
                v-model="form.public"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.invoice_delivery_types.form.description')"
            :hint="__('settings.invoice_delivery_types.form.description_hint')"
        >
            <DFormTextarea
                id="description"
                v-model="form.description"
                :placeholder="__('settings.invoice_delivery_types.form.description')"
                :is-valid="isFormFieldValid('description')"
                :invalid-feedback="errors.description"
                class="mb-0"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="$route('settings.invoice-delivery-types.index')"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    invoiceDeliveryType: {
        type: Object,
        default: () => { return {} }
    },
    availabilityTypes: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const form = useForm({
    public: props.invoiceDeliveryType.public ?? false,
    value: props.invoiceDeliveryType.value ?? null,
    availability: props.invoiceDeliveryType.availability ?? null,
    description: props.invoiceDeliveryType.description ?? null
})

const emit = defineEmits(['form-submitted'])
function submitForm () {
    emit('form-submitted', form)
}

</script>
